module.exports = __webpack_public_path__ + "static/media/matalanoireetA4suomeksi.b2ff22e9.jpg";